import { fetchbase } from '../../utils/api.util';
import { createApi } from '@reduxjs/toolkit/query/react';

export type MetaBuilderTag = 'MetaAdsAuth' | 'MetaAdsPages' | 'MetaAdsInstagramAccounts' | 'MetaAdsAdAccounts' | 'MetaAdsPixels' | 'MetaAdsSavedPixels' | 'MetaAdsCampaigns' | 'MetaAdsCampaignsFromMeta' | 'MetaAdsCampaignFromMeta' | 'DraftCampaigns' | 'BillingDetails' | 'MetaBuilderPricing';

export const emptyMetaBuilderSplitApi = createApi({
  reducerPath: 'metaBuilderApi',
  baseQuery: fetchbase,
  tagTypes: ['MetaAdsAuth', 'MetaAdsPages', 'MetaAdsInstagramAccounts', 'MetaAdsAdAccounts', 'MetaAdsPixels', 'MetaAdsSavedPixels', 'MetaAdsCampaigns', 'MetaAdsCampaignsFromMeta', 'MetaAdsCampaignFromMeta', 'DraftCampaigns', 'BillingDetails', 'MetaBuilderPricing'] as const,
  endpoints: () => ({}),
});
